import * as components from './components';

export default [
  {
    path: '/part-orders/:status?',
    component: components.PartOrderList,
    name: 'partOrdersList'
  }
];


// WEBPACK FOOTER //
// ./ClientApp/app/orders/routes.js